import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

import { logout } from '../../actions/auth';

import styles from './Header.module.css';

const Header = ({ logout }) => {
  return (
    <header className={styles.header}>
      <Link className={styles.logo} to="/">MealWell</Link>
      <nav className={styles.menuWrapper}>
        <ul className={styles.menu}>
          <li className={styles.menuItem}>
            <NavLink
              to="/"
              className={styles.menuLink}
            >
              Allergies
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/dishes"
              className={styles.menuLink}
            >
              Dishes
            </NavLink>
          </li>
          
          {/* <li className={styles.menuItem}>
            <NavLink
              to="/dish-priorities"
              className={styles.menuLink}
            >
              Dish Priorities
            </NavLink>
          </li> */}
          <li className={styles.menuItem}>
            <NavLink
              to="/ingredients"
              className={styles.menuLink}
            >
              Ingredients
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/products"
              className={styles.menuLink}
            >
              Products
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/disliked-products"
              className={styles.menuLink}
            >
              Disliked products
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/suggested-products"
              className={styles.menuLink}
            >
              Suggested products
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/mobile-users"
              className={styles.menuLink}
            >
              Mobile Users
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/web-users"
              className={styles.menuLink}
            >
              Web Users
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/help"
              className={styles.menuLink}
            >
              Support
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/deleted-users"
              className={styles.menuLink}
            >
              GDPR
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/blog"
              className={styles.menuLink}
            >
              Blog
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/authors"
              className={styles.menuLink}
            >
              Authors
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/banners"
              className={styles.menuLink}
            >
              Banners
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/pending-users"
              className={styles.menuLink}
              >
              Pending Users
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/pdf-downloads"
              className={styles.menuLink}
              >
              PDF Downloads
            </NavLink>
          </li>
          <li className={styles.menuItem}>
            <NavLink
              to="/settings"
              className={styles.menuLink}
            >
              Settings
            </NavLink>
          </li>
        </ul>
      </nav>
      <div className={styles.logout} onClick={logout}>
        Logout
      </div>
    </header>
  );
};

const mapDispatchToProps = {
  logout,
};

export default connect(null, mapDispatchToProps)(Header);
